import { observationBelongsToRow, type V2AiObservation } from '../domain/aiObservation';
import type { ReportOutputLanguage } from '../domain/report';
import { containsChinese } from './boundText';

// What the AI concluded on a Defect row, in the report language (iPhone real-photo run 2026-10-26, #10: the
// half bath's two defects printed only "A deficiency was observed at the time of inspection" — the AI had
// described both, but nobody had written the row's sentence yet). The library sentence of a Defect row with
// no inspector note states these facts (src/report/rowWording.ts rowReportSentence `defectFacts`).
//
// Only the observations that concluded a DEFECT — an AI "no visible defect" is never printed as the
// deficiency. An observation carries its text in the language of the report at the time of the analysis
// (`observation`) and in the App Language (`observationUi`, null when the two were the same), so the
// English client copy takes whichever text is free of Chinese — never Chinese (the closeout would block
// it) — and the Chinese copy prefers the Chinese text. At most two, the first ones on the row.
export const DEFECT_FACTS_MAX = 2;

function textFor(observation: Pick<V2AiObservation, 'observation' | 'observationUi' | 'headline'>, locale: ReportOutputLanguage): string {
  const candidates = [observation.observation, observation.observationUi ?? '', observation.headline].map((t) => t.trim()).filter((t) => t.length > 0);
  if (locale === 'en-US') return candidates.find((t) => !containsChinese(t)) ?? '';
  return candidates.find((t) => containsChinese(t)) ?? candidates[0] ?? '';
}

export function defectFactsOfItem(observations: readonly V2AiObservation[], itemId: string, locale: ReportOutputLanguage): string[] {
  const texts = observations
    .filter((o) => o.itemId === itemId && observationBelongsToRow(o) && o.verdict === 'defect')
    .sort((a, b) => a.createdAt - b.createdAt || a.sortOrder - b.sortOrder)
    .map((o) => textFor(o, locale))
    .filter((t) => t.length > 0);
  return [...new Set(texts)].slice(0, DEFECT_FACTS_MAX);
}
